@if (showAddBookmarkButton) { @if (!isBookmarking) {
<button
  type="button"
  data-e2e="cs-add-p-card-to-active-list"
  class="px-0 btn"
  atxTooltip="Add to active list"
  i18n-atxTooltip="
    Product card|add to active list button tooltip text@@addToActiveList"
  tooltipPlacement="top"
  (click)="addBookmarkClicked.emit()"
>
  <fa-icon
    [icon]="bookmarkIcon$ | async"
    data-e2e="save-product-to-list"
    class="p-card-icon"
  ></fa-icon>
</button>
} @else {
<div
  data-e2e="bookmarking-p-card-from-list"
  class="px-0 btn"
  atxTooltip="Adding to list..."
  i18n-atxTooltip="
    Product card|Boorkmarking tooltip text@@bookmarkingFromActiveList:"
  tooltipPlacement="top"
>
  <fa-icon
    [icon]="bookmarkedIcon$ | async"
    data-e2e="is-bookmarking-product-from-list"
    class="p-card-icon is-bookmarking cursor-not-allowed"
  ></fa-icon>
</div>
} } @else {
<button
  type="button"
  data-e2e="unclick-p-card-from-list"
  class="px-0 btn remove-from-list text-muted"
  atxTooltip="Remove from active list"
  i18n-atxTooltip="
    Product card|remove from active list button tooltip
    text@@removeFromActiveList:"
  tooltipPlacement="top"
  (click)="removeBookmarkClicked.emit()"
>
  <fa-icon
    [icon]="bookmarkedIcon$ | async"
    data-e2e="remove-product-from-list"
    class="p-card-icon"
  ></fa-icon>
</button>
}
